/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
import React, { Component } from 'react';

import { withStyles, createTheme, ThemeProvider } from '@material-ui/core/styles'

import { Tabs, Tab, Paper, TableContainer, Table, TableHead, TableRow, TableCell, TableBody, Typography} from '@material-ui/core'

import { FixedSizeList } from 'react-window';

const AntTabs = withStyles({
    root: {
      borderBottom: '1px solid #e8e8e8',
    },
    indicator: {
      backgroundColor: '#1890ff',
    },
})(Tabs);
  
const AntTab = withStyles((theme) => ({
    root: {
      textTransform: 'none',
      minWidth: 72,
      fontWeight: theme.typography.fontWeightRegular,
      marginRight: theme.spacing(4),
      fontFamily: [
        '-apple-system',
        'BlinkMacSystemFont',
        '"Segoe UI"',
        'Roboto',
        '"Helvetica Neue"',
        'Arial',
        'sans-serif',
        '"Apple Color Emoji"',
        '"Segoe UI Emoji"',
        '"Segoe UI Symbol"',
      ].join(','),
      '&:hover': {
        color: '#40a9ff',
        opacity: 1,
      },
      '&$selected': {
        color: '#1890ff',
        fontWeight: theme.typography.fontWeightMedium,
      },
      '&:focus': {
        color: '#40a9ff',
      },
    },
    selected: {},
}))((props) => <Tab disableRipple {...props} />);


const report_config = {
    summary : {
        headers : ['Parameter', 'Count'],
        rows : [
            {
                name: "Original Records",
                key : "num_records_orig"
            },
            {
                name : "Records Pre IFC",
                key : "num_records_pre_ifc"
            },
            {
                name : "Original Fields",
                key : "num_fields_orig"
            },
            {
                name : "Fields Pre IFC",
                key : "num_fields_pre_ifc"
            },
            {
                name : "Fields Post IFC",
                key : "num_fields_post_ifc"
            },
            {
                name : "Field Groups Identified",
                key : "num_field_groups"
            },
            {
                name : "Singleton Fields",
                key : "num_singleton_columns"
            },
            {
                name : "Low Count Drops",
                key : "num_low_count_drops"
            }
        ]
    },
    config : {
        headers: ['Parameter', 'Value'],
        rows : [
            {
                name : "Similarity Weight",
                key : "similarity_weight"
            },
            {
                name : "Clustering Threshold",
                key : "clustering_threshold"
            },
            {
                name : "Maximum Empty Threshold",
                key : "max_empty_threshold"
            },
            {
                name : "Name Column",
                key : "name_column"
            },
            {
                name : "Value Column",
                key : "value_column"
            }
        ]
    }
}

const blue_theme = createTheme({
    palette: {
      primary: {
        main: "#2296f3",
      },
      secondary: {
        main: "#dc014e",
      },
    },
});

const styles = theme => ({
    badge: {
        padding: `0 ${theme.spacing.unit * 0}px`,
    },
    headerStyle : {
        color : '#707070',
        backgroundColor : '#F5F5F5',
        fontSize : 11,
        border : 'none',
        paddingLeft : '20px'
    }
})

class IFCSummary extends Component {
    state = {
        tab_index : 0
    }

    renderTabContent = () => {
        return (
            <div style = {{width : '100%', height : (this.props.body_height - 50) + "px", overflow : 'auto', padding : '10px'}}>
                {this.state.tab_index === 0 && this.renderSummary()}
                {this.state.tab_index === 1 && this.renderParams()}
                {/* {this.state.tab_index === 2 && this.renderLowCountDrops()} */}
            </div>
        )
    }

    renderSummary = () => {
        return (
            <TableContainer
                style = {{maxHeight : (this.props.body_height - 70) + "px"}}
            >
                <Table
                    style = {{
                        borderCollapse : 'separate',
                        borderSpacing : '5px 5px',
                        marginRight : '10px',
                    }}
                    stickyHeader
                    size = 'small'
                >
                    {this.renderTableHeader(report_config.summary)}
                    {this.renderTableRows("report_summary")}
                </Table>
            </TableContainer>
        )
    }

    renderParams = () => {
        return (
            <TableContainer
                style = {{maxHeight : (this.props.body_height - 70) + "px"}}
            >
                <Table
                    style = {{
                        borderCollapse : 'separate',
                        borderSpacing : '5px 5px',
                        marginRight : '10px',
                    }}
                    stickyHeader
                    size = 'small'
                >
                    {this.renderTableHeader(report_config.config)}
                    {this.renderTableRows("operation_config")}
                </Table>
            </TableContainer>
        )
    }

    renderLowCountDrops = () => {
        const { classes } = this.props
        var toPX = require('to-px')
        console.log("IFC :: Low count drops : ", this.props.low_count_drops)
        if (this.props.low_count_drops.length > 0) {
            return (
                <div style = {{height : 'calc(100vh - 200px)'}}>
                    <TableContainer style = {{width : '100%'}}>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell
                                        className = {classes.headerStyle}
                                        padding = 'none' 
                                        size = 'small'
                                        align = 'left'
                                    >Name</TableCell>
                                    </TableRow>
                            </TableHead>
                            <TableBody>
                                {/* <FixedSizeList height = {toPX("100vh")} width = {toPX("25vw") - 40} itemSize = {50} itemCount = {this.props.low_count_drops.length}>
                                    {(index, style) => (
                                        <TableRow
                                            style = {{
                                                ...style,
                                                backgroundColor : '#FFFFFF',
                                                padding : '5px',
                                                cursor : 'pointer',
                                            }}
                                        >
                                            <TableCell>{this.props.low_count_drops[index]}</TableCell>
                                        </TableRow>
                                    )}
                                </FixedSizeList> */}
                                {this.props.low_count_drops.map(drop => (
                                    <TableRow
                                        style = {{
                                            backgroundColor : '#FFFFFF',
                                            padding : '5px',
                                        }}
                                    >
                                        <TableCell>{drop}</TableCell>
                                </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </div>
            )
        } else {
            return (
                <div style = {{height : 'calc(100vh - 200px)', padding : '10px'}}>
                    <Typography variant = 'caption' color = 'textSecondary' align = 'center'> No records were dropped.</Typography>
                </div>
            )
        }
    }

    renderTableHeader = (data) => {
        const { classes } = this.props
        return (
            <TableHead>
                <TableRow>
                    {data.headers.map(header => {
                        return (
                            <TableCell
                                className = {classes.headerStyle}
                                padding = 'none' 
                                size = 'small'
                                align = 'left'
                            >{header}</TableCell>
                        )
                    })}
                </TableRow>
            </TableHead>
        )
    }

    renderTableRows = (from) => {
        let keys = Object.keys(this.props.report_info[from])
        return (
            <TableBody>
                {keys.map(key => {
                    return (
                        <TableRow
                            style = {{
                                backgroundColor : '#FFFFFF',
                                padding : '5px',
                                width : '90%',
                                cursor : 'pointer',
                            }}
                        >
                            <TableCell>{this.props.report_info[from][key].display_name}</TableCell>
                            <TableCell style = {{fontWeight : 700, color : '#2296f3'}}>{(this.props.report_info[from][key].value === null || (Array.isArray(this.props.report_info[from][key].value) && this.props.report_info[from][key].value.length === 0)) ? "NA" : this.props.report_info[from][key].value.toString()}</TableCell>
                        </TableRow>
                    )
                })}
            </TableBody>
        )
    }



    render() { 
        return (
            <ThemeProvider thene = {blue_theme}>
                <Paper
                    square
                    variant = 'outlined'
                    style = {{width : '100%', height : '50px'}}
                >
                    <AntTabs
                        value={this.state.tab_index}
                        variant = 'scrollable'
                        scrollButtons="auto"
                        indicatorColor="primary"
                        textColor="primary"
                        onChange = {(event, newValue) => this.setState({...this.state, tab_index : newValue})}
                    >
                        <AntTab label = "Report Summary"/>
                        <AntTab label = "Configuration Parameters"/>
                        {/* <AntTab label = "Low Count Drops"/> */}
                    </AntTabs>
                </Paper>
                {this.renderTabContent()}
            </ThemeProvider>
        );
    }
}
 
export default withStyles(styles)(IFCSummary);